import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Collapse from './src/collapse.vue'
import CollapseItem from './src/collapse-item.vue'

export const JdCollapse = withInstall(Collapse, {
  CollapseItem,
})
export default JdCollapse
export const JdCollapseItem = withNoopInstall(CollapseItem)

export * from './src/collapse'
export * from './src/collapse-item'
export * from './src/constants'
export type { CollapseInstance, CollapseItemInstance } from './src/instance'
